import classNames from 'classnames';
import pluralize from 'pluralize';
import React, { MouseEventHandler } from 'react';
import StepCollapsed from 'src/components/Shared/StepCollapsed/StepCollapsed';
import words from 'src/utils/words';

export interface AutoSellFundSummaryProps {
  clickable: boolean;
  onEditClick: MouseEventHandler<HTMLDivElement>;
  sellSelectedFundsWithAmountCount: number;
}

export const AutoSellFundSummary: React.FC<AutoSellFundSummaryProps> = ({
  clickable,
  onEditClick,
  sellSelectedFundsWithAmountCount,
}) => {
  if (sellSelectedFundsWithAmountCount <= 0) {
    return null;
  }
  return (
    <div
      className={classNames('sell-fund-summary', {
        'sell-fund-summary-pointer': clickable,
        'sell-fund-summary-non-pointer': !clickable,
      })}
      onClick={clickable ? onEditClick : undefined}
    >
      <StepCollapsed>
        <span className="sell-fund-summary-text">
          Automatic Sell selected for{' '}
          {pluralize(words.fund, sellSelectedFundsWithAmountCount, true)}
        </span>
        <a
          className="college-branded-link sell-fund-summary-edit-link"
          id="sell-step-2-edit"
        >
          Edit
        </a>
      </StepCollapsed>
    </div>
  );
};
